import React from 'react';
import ServicePage from '../components/services/ServicePage';
import magneticPanels from '../data/services/magnetic-panels';

const MagneticPanels: React.FC = () => <ServicePage data={magneticPanels} />;

export default MagneticPanels;
